var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group",class:_vm.wrapperClass},[(!!_vm.$slots.prepend)?_c('div',{staticClass:"input-group-prepend"},[_vm._t("prepend")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-group-input"},[_vm._t("default")],2),_vm._v(" "),(!!_vm.$slots.append)?_c('div',{staticClass:"input-group-append"},[_vm._t("append")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }